
(function documentTypeControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminDocumentTypeService', 'authExtend', 'functionService',
            function documentTypeController($scope, config, $state, $translate, errors, $stateParams, adminDocumentTypeService, authExtend, functionService) {
                $scope.canSetMaxVersions = authExtend.isInRole('DOCUMENTTYPE MAX VERSIONS');
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');

                $scope.title = 'DocumentTypeAdd';

                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.documentType =
                    {
                        name: '',
                        systemName: '',
                        app: [],
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()

                    };
                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                $scope.selectApp = function (item) {
                    if (!Array.isArray($scope.tempApp)) {
                        $scope.tempApp = [];
                    }

                    $scope.tempApp.push(item)
                };

                $scope.removeApp = function (item) {
                    var index = $scope.tempApp.indexOf(item);
                    if (index > -1) {
                        $scope.tempApp.splice(index, 1);
                    }
                };


                $scope.save = function () {
                    if (!$scope.documentTypeForm.$valid) {
                        $scope.documentTypeForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    if ($scope.tempApp) {
                        $scope.documentType.Applications = [];
                        $scope.tempApp.forEach(function (item) {
                            $scope.documentType.Applications.push({ ApplicationId: item.id });
                        });
                    }

                    $scope.documentType.maxDocumentVersion = $scope.documentType.maxDocumentVersion == 0 ? null : $scope.documentType.maxDocumentVersion;

                    adminDocumentTypeService.create($scope.documentType).then(function (documentType) {
                        if (documentType && documentType.id) {
                            $state.go('document-type-metadata', { id: documentType.id });
                        }
                        else {
                            $state.go('document-type-find');
                        }

                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("document-type-find");
                };

            }
        ]);
})();